import { render } from "./PairsEvaluationv2.vue?vue&type=template&id=04fc6c06"
import script from "./PairsEvaluationv2.vue?vue&type=script&lang=js"
export * from "./PairsEvaluationv2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__